module.exports = __webpack_public_path__ + "assets/img/homme-et-femme.a4931bb7.jpg";